import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import './FirstSectionFeatured.scss';
import decorationSvg from '../../../assets/Images/Featured Playlists bg element.svg';  // Ensure these paths are correct
import UnifiedButton from '../../shared/Button';
import { useNavigate } from 'react-router-dom';

const FirstSectionFeatured = () => {
    const navigate = useNavigate()

    const handleplaylistformClick = () => {
        console.log('Navigating to /pricing');
        navigate('/support/legal-forms/2');
        window.scrollTo(0, 0);
    };
    return (
        <Box className="featured-playlists">
            <img src={decorationSvg} alt="Top Left Decoration" className="top-left-decoration" />
            <img src={decorationSvg} alt="Bottom Right Decoration" className="bottom-right-decoration" />

            <Box className="content">
                <Box className="title-wrapper">
                    <img src={decorationSvg} alt="Left Decoration" className="side-decoration" />
                    <Typography variant="h2" className="title">
                        Featured Playlists
                    </Typography>
                    <img src={decorationSvg} alt="Right Decoration" className="side-decoration" />
                </Box>
                <Typography variant="h4" className="sub-title">
                    Spotify, Gaana
                </Typography>
                <Typography variant="body1" className="description">
                    No matter what kind of music you create, our editorial team wants to hear it!
                    With thousands of followers on our playlists worldwide, submit your tracks for a
                    chance to be featured.
                </Typography>
                <UnifiedButton onClick={handleplaylistformClick} className="cta-button" textContent={"Submit your song now"} />


            </Box>
        </Box>
    );
};

export default FirstSectionFeatured;
